import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ReactPlayer from 'react-player'
import 'react-loading-bar/dist/index.css';

const context = "Sliderimages.js";
var Photo1, Photo2, Photo3, Photo4, options;

const photos = [
    {
        name: Photo1,

        url: "assets/custom_icons/involvements/h4.jpg"
    },
    {
        name: Photo2,
        url: "assets/custom_icons/involvements/h2.jpg"
    },
    {
        name: Photo3,
        url: "assets/custom_icons/involvements/h3.jpg"
    },
    {
        name: Photo4,
        url: "assets/custom_icons/involvements/h.jpg"
    }

]
// const divStyle = {
//     position: 'relative'
// }
var self = null;
@inject("appStore")
@observer
class Sliderimages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }



    componentWillMount = () => {
        self = this;
    }


    render() {
        return (
            //             <div>
            //                 <div className="container">
            //                            <div className="section-title">
            //                             <h2>Involvements ...</h2>
            //                             </div> 
            //                      <div class="row justify-content-center">
            //                          <div class="col-lg-6 col-md-12">
            //                          <div><h3>Schools Visited</h3></div>
            //                            <Slider {...settings}>

            //                                 {photos.map((photo) =>  {
            //                                     return(

            //                                     <div>
            //                                         <img width="550" height="350"  src={photo.url}/>
            //                                     </div>
            //                                     )
            //                                 })}
            //                                 </Slider>
            //                          </div>

            //                          <div class="col-lg-6 col-md-12">

            //                           <h3 >Association with Radio Mirchi..</h3>

            //                                                    {/* <iframe width="600" height="350" src="assets/custom_icons/involvements/hexa.mp4" frameborder="0" title="hexa_radio"  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
            //                         {/* <ReactPlayer url='https://www.youtube.com/watch?v=ysz5S6PUM-U' playing /> */}
            //                            <ReactPlayer
            //                                 url='assets/custom_icons/involvements/hexa.mp4'
            //                                 className='react-player'
            //                                 controls='true'
            //                                 width='550'
            //                                 height='350'
            //                                 style={divStyle}
            // />                         </div>                        
            //                          </div>   
            //             </div>
            // </div>

            <div>
                {/* <section className="pt-120 pb-120 section-pattern ov-hidden">

                    <div className="container">
                        <h2>Involvements ...</h2>

                        <div className="row align-items-center">

                            <div className="col-lg-6 col-md-12 col-sm-12"  >

                                <h3>Schools Visited.</h3>

                                <Slider {...settings}>

                                    {photos.map((photo) => {
                                        return (

                                            <div>
                                                <img src={photo.url} />
                                            </div>
                                        )
                                    })}</Slider>


                            </div>



                            <div className="col-lg-6 col-md-12 col-sm-12 video-area">
                                <h3>Association with Radio Mirchi.</h3>
                                <div className="mt-10">
                                    <ReactPlayer
                                        url='assets/custom_icons/involvements/hexa.mp4'
                                        className='react-player'
                                        controls='true'
                                        width='500'
                                        height='300'

                                    ></ReactPlayer>
                                </div>

                            </div>
                        </div>
                    </div>
                </section> */}







                <section className="pt-120 section-pattern ov-hidden">
                    <div className="container">
                        <div className="section-title">
                            <h3>Involvements ...</h3>
                            {/* <h2>Real time tracking application for your child's safety </h2> */}
                            {/* <p></p> */}
                            <h2>Association with schools and Radio Mirchi.</h2>
                        </div>

                        <div className="row align-items-center">





                            <div className="col-lg-6 col-md-12 col-sm-12" style={{ marginBottom: '5%' }}>

                                <div className="player-wrapper">

                                    
                                    <ReactPlayer
                                        url='assets/custom_icons/involvements/hexa_banner.mp4'
                                        className='react-player'
                                        controls='true'
                                        width='100%'
                                        height='100%'

                                    ></ReactPlayer>
                                </div>

                            </div>

                            <div className="col-lg-6 col-sm-12 col-md-12 mb-20 mt-20">

                                <div class="about-apps-slider owl-carousel " id="involve_carousel">


                                    {photos.map((photo) => {
                                        return (

                                            <div>
                                                <img src={photo.url} />
                                            </div>
                                        )
                                    })}</div>

                                {/* <p>hi</p> */}

                            </div>

                        </div>
                        <div className="section-title">
                            <h3>Hexa School and its events ...</h3>
                            {/* <h2>Real time tracking application for your child's safety </h2> */}
                            {/* <p></p> */}
                            {/* <h2>Association with schools and Radio Mirchi.</h2> */}
                        </div>
                        <div className="row align-items-center">

                            <div className="col-lg-4 col-md-4 col-sm-12" style={{ marginBottom: '5%' }}>
                            <h4>Hexa with new features.</h4>
                                <div className="player-wrapper">
                                
                                    <ReactPlayer
                                        url='assets/custom_icons/involvements/Hexa_fea.mp4'
                                        className='react-player'
                                        controls='true'
                                        width='100%'
                                        height='100%'

                                    ></ReactPlayer>
                                </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12" style={{ marginBottom: '5%' }}>
                                <h4>The Danger of the Last Kid.</h4>
                                <div className="player-wrapper">
                               
                                    <ReactPlayer
                                        url='assets/custom_icons/involvements/lastkid.mp4'
                                        className='react-player'
                                        controls='true'
                                        width='100%'
                                        height='100%'

                                    ></ReactPlayer>
                                </div>
                                </div>
                                
                                <div className="col-lg-4 col-md-4 col-sm-12" style={{ marginBottom: '5%' }}>
                                <h4>Sleepless Nights for Parents?</h4>

                                <div className="player-wrapper">
                                
                                    <ReactPlayer
                                        url='assets/custom_icons/involvements/Hexa_1_sleep.mp4'
                                        className='react-player'
                                        controls='true'
                                        width='100%'
                                        height='100%'
                                    ></ReactPlayer>
                                </div>
                                </div>
                                 
                                <div className="col-lg-4 col-md-4 col-sm-12" style={{ marginBottom: '5%' }}>
                                <h4>Hexa School with Team Hami.</h4>

                                <div className="player-wrapper">
                                
                                    <ReactPlayer
                                        url='assets/custom_icons/involvements/hami_crp.mp4'
                                        className='react-player'
                                        controls='true'
                                        width='100%'
                                        height='100%'
                                    ></ReactPlayer>
                                </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12" style={{ marginBottom: '5%' }}>
                                <h4>Hexa App on News.</h4>

                                <div className="player-wrapper">
                                
                                    <ReactPlayer
                                        url='assets/custom_icons/involvements/news_crp.mp4'
                                        className='react-player'
                                        controls='true'
                                        width='100%'
                                        height='100%'
                                    ></ReactPlayer>
                                </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12" style={{ marginBottom: '5%' }}>
                                <h4>Avoid rush hour in morning.</h4>

                                <div className="player-wrapper">
                                
                                    <ReactPlayer
                                        url='assets/custom_icons/involvements/rush_crp.mp4'
                                        className='react-player'
                                        controls='true'
                                        width='100%'
                                        height='100%'
                                    ></ReactPlayer>
                                </div>
                                </div>
                            </div>
                        </div>
                    

                </section>



            </div>
        );
    }

}

export default withRouter(Sliderimages);


// WEBPACK FOOTER //
// ./src/Pages/Sliderimages.js